<template>
  <div>
    <vue-plotly
      :data="chartData"
      :options="chartOptions"
      :layout="layout"
    ></vue-plotly>
  </div>
</template>

<script>
import VuePlotly from "@statnett/vue-plotly";
import OZG_IMPLEMENATION_EXPLANATIONS from "../store/const.js";
console.log(OZG_IMPLEMENATION_EXPLANATIONS.OZG_IMPLEMENATION_EXPLANATIONS);
export default {
  name: "OZGImplentationStatusGraph",
  props: ["query", "onlyOZGRelevant"],
  data() {
    return {
      aggregateOnImplementationLevel: null,
      chartData: {},
      chartOptions: {
        sort: false
      },
      layout: {
        showlegend: true,
        legend: { orientation: "h" }
      },

      gqlquery: this.query
    };
  },
  methods: {
    renderGraph: function(newVal) {
      console.log(newVal);
      var impl = {};

      for (var x in newVal) {
        // Shows only the explicitly set index of "5", and ignores 0-4
        impl[newVal[x].implementationStatus] = newVal[x].count;
      }

      var values = [
        impl["null"],
        impl["0"],
        impl["1"],
        impl["2"],
        impl["3"],
        impl["4"]
      ];
      var labels = [
        OZG_IMPLEMENATION_EXPLANATIONS.OZG_IMPLEMENATION_EXPLANATIONS[null],
        OZG_IMPLEMENATION_EXPLANATIONS.OZG_IMPLEMENATION_EXPLANATIONS[0],
        OZG_IMPLEMENATION_EXPLANATIONS.OZG_IMPLEMENATION_EXPLANATIONS[1],
        OZG_IMPLEMENATION_EXPLANATIONS.OZG_IMPLEMENATION_EXPLANATIONS[2],
        OZG_IMPLEMENATION_EXPLANATIONS.OZG_IMPLEMENATION_EXPLANATIONS[3],
        OZG_IMPLEMENATION_EXPLANATIONS.OZG_IMPLEMENATION_EXPLANATIONS[4]
      ];

      if (this.$props.onlyOZGRelevant) {
        values = [
          impl["null"] + impl["0"] + impl["1"] + impl["2"],
          impl["3"] + impl["4"]
        ];
        labels = ["nicht OZG-Konform umgesetzt", "OZG-Konform umgesetzt"];
      }

      var data = [
        {
          values: values,
          labels: labels,
          hovertemplate:
            "%{label}<br>Leistungen: <b>%{value} - %{percent} </b> <extra></extra>",

          type: "pie",
          sort: false
        }
      ];

      this.chartData = data;
    }
  },
  watch: {
    aggregateOnImplementationLevel: function(newVal) {
      this.renderGraph(newVal);
    },
    onlyOZGRelevant: function() {
      this.renderGraph(this.aggregateOnImplementationLevel);
    }
  },
  components: { VuePlotly },

  apollo: {
    $client: "ozgClient",
    aggregateOnImplementationLevel: {
      query() {
        var mapping = {
          "on-max-feature": require("../graphql/ozgServiceAggregateOnMaxFeatureStatus.gql"),
          "on-min-feature": require("../graphql/ozgServiceAggregateOnMinFeatureStatus.gql"),
          "on-service": require("../graphql/ozgServiceAggregateOnImplementationStatus.gql")
        };
        return mapping[this.gqlquery];
      }
    }
  }
};
</script>

<style scoped>
.chart {
}
</style>
